<template>
  <div>
    <v-dialog :title="data ? 'Edit Push' : 'Create Push'" :visible.sync="dialogVisible" width="65vw" @open="onOpen"
      @closed="onClosed">
      <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" label-width="150px" v-loading="loading">
        <el-form-item label="" prop="">
          <p class="right-find">
            <i class="el-icon-warning-outline"></i>请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站：
            <a href="https://www.rightfind.com" target="_blank">https://www.rightfind.com</a>
          </p>
        </el-form-item>
        <el-form-item label="Greetings" prop="greeting">
          <el-input class="greet-input" placeholder="Please input greetings" v-model="form.greeting" maxlength="100" />
        </el-form-item>
        <el-form-item ref="pushToMSL" label="Setting" prop="pushToMSL" style="margin-bottom: 5px!important;">
          <div>
            <el-checkbox v-model="form.pushToMSL" :disabled="disablePushToMSL">Push to Me</el-checkbox>
            <el-button v-if="disablePushToMSL" class="bind-wechat-link" type="text" @click="bindWeChat()">
              Bind WeChat?
            </el-button>
          </div>
          <div class="push-to-msl-msg" slot="error">{{ pushToMSLMsg }}</div>
          
        </el-form-item>
        <el-form-item :style="{'margin-bottom': form.scheduled?'16px!important':'5px!important'}" prop="scheduleDate">
          <div>
            <el-checkbox v-model="form.scheduled" @change="onScheduleChange" :true-label="1" :false-label="0">
              Scheduled
            </el-checkbox>
            <el-row v-if="form.scheduled">
              <el-col :span="4"><el-date-picker v-model="sDate" type="date" :format="dateFormat"
                  :value-format="dateFormat" placeholder="Select Date" :editable="false" /></el-col>
              <el-col :span="4"> <el-select class="times-select" v-model="sTime" clearable allow-create filterable
                  placeholder="Select Time" @blur="onTimeBulr($event, 'sTime')" ref="sTime">
                  <i slot="prefix" class="el-input__icon el-icon-time"></i>
                  <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                </el-select></el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item ref="isWeComSend"  prop="isWeComSend" style="margin-bottom: 5px!important;">
          <div class="checkbox-wrapper">
            <el-checkbox v-model="form.isWeComSend" >WeCom Send</el-checkbox>
            <el-checkbox v-if="form.isWeComSend" v-model="form.contactsOnly" @change="onContactsOnlyChange" >Contacts Only</el-checkbox>
          </div>
          
        </el-form-item>

        <el-form-item label="Tag" class="push-tag-filter">
          <HcpTagSelect v-model="selectedTagIds" />
        </el-form-item>

        <el-form-item ref="seIds" :label="formItemLabel" prop="seIds">
          <el-radio-group v-model="seType" @input="changeSeType" v-if="isSupervisor || isMSL">
            <el-radio label="All">All</el-radio>
            <el-radio label="SE">SE</el-radio>
            <el-radio label="CE">CE</el-radio>
          </el-radio-group>
          <SEMultipleSelect v-model="form.seIds" :showTips="true" :placeholder="selectPlaceholder"
            :options="seListByType" @select-change="onSESelectChange" type="quickPush" />
          <div class="selected-hcp-count">
            Selected: <strong>{{ form.seIds.length }}</strong>
          </div>
        </el-form-item>

        <el-form-item prop="requestType" label="Request Type" class="request-type">
          <el-select v-model="form.requestType" placeholder="Please Select Request Type" :loading="requestTypeLoading"
            @change="onRequestTypeChange">
            <el-option v-for="type in pushTypes" :key="type.key" :label="type.value" :value="type.key">
            </el-option>
          </el-select>
          <template v-if="form.requestType === 0">
            <el-input style="margin-top: 15px;" v-model="form.requestContent" placeholder="Please input reason"
              :maxlength="200" />
          </template>
          <template v-if="form.requestType === 1">
            <el-row type="flex" align="bottom" class="row-line" justify="space-between">
              <el-col class="interaction-date-time" :span="12">
                <el-form-item prop="interactionDateTime" label="Interaction date/time" class="top-label">
                  <div class="datetime">
                    <el-col :span="12">
                      <el-date-picker v-model="iDate" type="date" :format="dateFormat" :value-format="dateFormat"
                        placeholder="Date" :editable="false" />
                    </el-col>
                    <el-col :span="12">
                      <el-select class="times-select" v-model="iTime" clearable allow-create filterable
                        placeholder="Time" @blur="onTimeBulr($event, 'iTime')" ref="iTime">
                        <i slot="prefix" class="el-input__icon el-icon-time"></i>
                        <el-option v-for="(item, i) in times" :key="i" :label="item.value" :value="item.value" />
                      </el-select>
                    </el-col>
                  </div>
                </el-form-item>
              </el-col>
              <el-col class="interaction-type" :span="8">
                <el-form-item prop="interactionTypeId" label="Interaction type" class="top-label">
                  <el-select v-model="form.interactionTypeId" placeholder="Interaction type">
                    <el-option v-for="t in interTypes" :label="t.value" :value="t.key" :key="t.key" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <template v-if="form.requestType === 6 || form.requestType === 5">
            <el-input style="margin: 15px 0 10px;" v-model="form.requestContent" placeholder="Please input reason" />
            <CheckboxGroup v-model="form.initActivities" class="activity_options">
              <Checkbox v-for="activity in activityOptions" :key="activity.optionId" :label="activity.optionId"
                style="display: block;">
                {{ activity.optionValue }}
              </Checkbox>
            </CheckboxGroup>
          </template>
        </el-form-item>
        <el-form-item label="Request Content" v-if="form.requestType === 1">
          <el-input class="greet-input" placeholder="Please input request content" v-model="form.requestContent"
            :maxlength="200" />
        </el-form-item>
        <el-form-item label="Push Content">
          <el-button plain @click="showSelectDialog" style="margin-right: 10px;">
            Select Content
          </el-button>
          <el-button plain @click="showNewPaperDialog">
            Upload Content
          </el-button>
          <ul class="upload-files">
            <li class="upload-file-item" v-for="(file, i) in files" :key="i">
              <a :href="file.AttachmentPath" target="_blank" :title="file.Content">
                <i class="el-icon-document"></i>
                {{ file.Content }}
              </a>
              <span @click="deleteFile(i)">
                <i class="el-icon-close"></i>
              </span>
            </li>
          </ul>
        </el-form-item>
        <el-form-item
          label="Full Article Request"
          prop="fullPaperRequest"
        >
          <el-radio-group v-model="form.fullPaperRequest">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Description" class="editor" prop="paperContent">
          <TinymceEditor v-if="visible" :height="200" v-model="form.paperContent" />
        </el-form-item>


      </el-form>

      <div slot="footer" class="footer">
        <el-button type="primary" @click="onPreview" :loading="previewing || loading">
          {{ previewLabel }}
        </el-button>
        <el-button type="primary" @click="onSubmit(1)" :disabled="actionDisabled" :loading="loading">
          Submit
        </el-button>
        <el-button @click="onSubmit(0)" :disabled="actionDisabled" :loading="loading">
          Save Draft
        </el-button>
      </div>

    </v-dialog>
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="previewUrl" />
    <SelectContentDialog ref="selectContentDialog" :visible.sync="selectContentDialogVisible"
      :selected="selectTableData" :categoried="form.categoried" :paper-content="form.paperContent"
      @select="onSelect" @closed="onSelectDialogClosed" @clear-description="onClearDescription" />
    <PaperDialog :visible.sync="newPaperDialogVisible" :paper-content="form.paperContent" @success="onFileUpload" @closed="onSelectDialogClosed" @clear-description="onClearDescription" />
<!-- 自定义HCP确认对话框 -->
  <el-dialog
    title="请确认推送的HCP"
    :visible.sync="customConfirmVisible"
    width="40%"
    class="custom-confirm-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="confirm-content">
      <div v-if="confirmedContactsNames" class="contact-group">
        <div class="contact-title">已添加MSL企业微信联系人：<span class="contact-names">{{ confirmedContactsNames }}</span></div>
        <div class="contact-desc">(可推送至医生微信)</div>
      </div>
       <div class="confirm-divider" v-if="unconfirmedContactsNames.length > 0 && confirmedContactsNames.length > 0"></div>
      <div v-if="unconfirmedContactsNames" class="contact-group">
        <div class="contact-title">未添加MSL企业微信联系人：<span class="contact-names">{{ unconfirmedContactsNames }}</span></div>
        <div class="contact-desc">(不可推送至医生微信)</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="customConfirmCancel">Cancel</el-button>
      <el-button type="primary" @click="customConfirmSubmit">Submit</el-button>
    </span>
  </el-dialog>
  </div>

  
</template>

<script>
import SelectContentDialog from "./select-online-content-dialog";
import TinymceEditor from "../../../components/tinymce-editor.vue";
import { getTimes } from "@/utils/datetime";
import { trimValidate } from "@/utils/validator";
// import MultipleFileUpload from "../../../components/multiple-file-upload";
import QRCodeDialog from "../qrcode-dialog.vue";
// import { filesHandler } from "@/utils";
import { RoleCode } from "@/utils/role-constant";
import SEMultipleSelect from "@/components/se-multiple-select";
import HcpTagSelect from "@/components/hcp-tag-select.vue";
import { hcpMatchesTagFilter } from "@/utils/hcp-tag-catalog";
import { CheckboxGroup, Checkbox } from 'element-ui';
import PaperDialog from "@/views/content/content/paper-dialog.vue";

export default {
  name: "quick-push-dialog",
  components: {
    SEMultipleSelect,
    // MultipleFileUpload,
    TinymceEditor,
    QRCodeDialog,
    SelectContentDialog,
    CheckboxGroup,
    Checkbox,
    PaperDialog,
    HcpTagSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const validatePushToMSL = (rule, value, callback) => {
      if (
        this.isSelectSEUncertified &&
        !this.pushToMSL &&
        !value
      ) {
        return callback(new Error());
      }
      callback();
    };
    return {
      seType: 'All',
      selectedTagIds: [],
      dialogVisible: this.visible,
      actionDisabled: false,
      dateFormat: "yyyy-MM-dd",
      form: {
        greeting: "",
        pushToMSL: false,
        seIds: [],
        fullPaperRequest:null,
        paperContent: "",
        scheduled: 0,
        scheduleDate: null,
        isWeComSend: false,
        contactsOnly: false,
        requestType: null,
        interactionTypeId: null,
        interactionDateTime: null,
        requestContent: "",
        papers: [], // {paperCateId:"",msgCateId:""}
        initActivities: [],
      },
      uploadFiles: [],
      formRules: {
        greeting: [
          {
            required: true,
            validator: trimValidate("Please input greetings"),
            message: "Please input greetings",
            trigger: "blur",
          },
        ],
        pushToMSL: {
          type: "boolean",
          required: false,
          trigger: "change",
          validator: validatePushToMSL,
        },
        seIds: {
          required: true,
          type: "array",
          message: "Please select HCP",
          trigger: "change",
        },
        requestType: {
          required: true,
          message: "Please select rquest type",
          trigger: "change",
        },
        paperContent: [
          {
            required: true,
            message: "Please input content",
            trigger: "blur",
          },
        ],
        fullPaperRequest: [
          {
            type: "number",
            required: true,
            message: "Please select full article request",
            tigger: "change",
          },
        ],
        scheduleDate: [
          {
            required: false,
            message: "Please select schedule date and time",
            tigger: "change",
          },
        ],
        interactionDateTime: [
          {
            required: true,
            message: "Please select interaction date and time",
            tigger: "change",
          },
        ],
        interactionTypeId: [
          {
            required: true,
            message: "Please select interaction type",
            tigger: "change",
          },
        ],
      },
      seList: [],
      businessPurposeList: [],
      securityLevelsList: [],
      isSelectSEUncertified: false,
      previewing: false,
      qrcodeDialogVisible: false,
      previewUrl: null,
      sDate: "",
      sTime: "",
      iDate: "", // interaction date
      iTime: "", // interaction time
      hidePushDialog: false,
      priorities: [],
      interTypes: [],
      pushTypes: [],
      activityOptions: [],
      selectContentDialogVisible: false,
      selectTableData: [],
      requestTypeLoading: false,
      newPaperDialogVisible: false,
      loading: false,
      originalPaperContent: "",
      // 自定义确认对话框相关数据
      customConfirmVisible: false,
      // 模拟HCP联系人数据
      confirmedContacts: [],
      unconfirmedContacts: [],
      isMock:false,
      // 用于保存原始seList数据，在contactsOnly勾选/取消时使用
      originalSeList: null
    };
  },
  computed: {
    times() {
      return getTimes("00:00", "23:30", "00:30", "00:00", "23:30");
    },
    token() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    disablePushToMSL() {
      return this.userInfo.bindStatus !== 2;
    },
    pushToMSLMsg() {
      return this.disablePushToMSL
        ? `Please bind WeChat first then check 'Push to Me' option`
        : this.form.pushToMSL
          ? ""
          : `Please check 'Push to Me' option`;
    },
    previewLabel() {
      return this.previewing ? "Previewing" : "Preview";
    },
    files() {
      return this.uploadFiles
    },
    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.ML || role === RoleCode.Supervisor
        ? "HCP"
        : (role === RoleCode.VMSL ? 'vCE' : "Customer");
    },
    formItemLabel() {
      return `Select ${this.nameLabel}`;
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    isBatchPush() {
      return this.form.seIds.length > 1;
    },
    seIds() {
      return `'${this.form.seIds.toString().replace(",", "','")}'`;
    },
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
    isMSL() {
      return this.$store.state.role === RoleCode.ML;
    },
    seListByType() {
      let list = this.seList
      if (this.seType !== 'All') {
        list = list.filter(item => item.types ? item.types.includes(this.seType) : false)
      }
      if (this.selectedTagIds.length) {
        list = list.filter(item => hcpMatchesTagFilter(item.Tags, this.selectedTagIds))
      }
      return list
    },
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL;
    },
    hasDescriptionChanged() {
      return this.form.paperContent !== this.originalPaperContent;
    },
    // 格式化已添加的联系人名称
    confirmedContactsNames() {
      return this.confirmedContacts && this.confirmedContacts.length > 0 ? this.confirmedContacts.join('，') : '';
    },
    // 格式化未添加的联系人名称
    unconfirmedContactsNames() {
      return this.unconfirmedContacts && this.unconfirmedContacts.length > 0 ? this.unconfirmedContacts.join('，') : '';
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
    sDate(value) {
      this.form.scheduleDate =
        value && this.sTime ? `${value} ${this.sTime}` : "";
    },
    sTime(value) {
      this.form.scheduleDate =
        value && this.sDate ? `${this.sDate} ${value}` : "";
    },
    iDate(value) {
      this.form.interactionDateTime =
        value && this.iTime ? `${value} ${this.iTime}` : "";
    },
    iTime(value) {
      this.form.interactionDateTime =
        value && this.iDate ? `${this.iDate} ${value}` : "";
    },
    selectedTagIds() {
      const validIds = this.seListByType.map(item => item.SEID)
      this.form.seIds = this.form.seIds.filter(id => validIds.includes(id))
    },
    selectTableData(value) {
      this.form.papers = Array.from(value, (i, index) => {
        return {
          paperId: i.PaperID,
          shortTitle: i.ShortTitle,
          paperCateId: i.PaperCategoryID,
          sequence: index + 1,
        };
      });
    },
  },
  created() {
    this.formRules.seIds.message = this.selectPlaceholder;
  },
  methods: {
    onTimeBulr(e, ref) {
      let timeDom = this.$refs[ref];
      if (timeDom) {
        const reg = /([01]?[0-9]|2[0-3]):[0-5][0-9]/;
        if (timeDom.selectedLabel) {
          if (reg.test(timeDom.selectedLabel)) {
            this.$set(this, ref, timeDom.selectedLabel);
          } else {
            timeDom.deleteSelected(e);
          }
        }
      }
    },
    changeSeType() {
      this.form.seIds = []
    },
    onClosed() {
      this.checkBindWeChatStatus();
      if (!this.hidePushDialog) {
        this.$refs['form'].resetFields();
        this.$refs.selectContentDialog.resetToFirstPage();
        this.form.papers = [];
        this.form.requestContent = '';
        this.form.initActivities = []
        // // this.form.sch;
        this.iDate = "";
        this.iTime = "";
        this.selectTableData = [];
        this.form.isWeComSend = false
        this.form.contactsOnly = false,
        this.form.scheduled = false
        this.form.scheduleDate = null;
        this.formRules.scheduleDate[0].required = false;
        this.formRules.interactionDateTime[0].required = false;
        this.formRules.interactionTypeId[0].required = false;
        this.$emit("update:visible", false);
        this.seType = 'All'
        this.selectedTagIds = []
        this.$refs.form.resetFields();
        this.$set(this.formRules.pushToMSL, "required", false);
        this.isSelectSEUncertified = false;
        this.actionDisabled = false;
        this.previewing = false;
        this.uploadFiles = [];
        this.formRules.scheduleDate[0].required = false;
        this.sDate = "";
        this.sTime = "";
        this.form.fullPaperRequest = null;
        this.originalPaperContent = ""
        this.form.greeting = null
        this.form.seIds = []
        this.form.requestType = null
      }
    },
    onRequestTypeChange(value) {
      this.formRules.interactionDateTime[0].required = value === 1;
      this.formRules.interactionTypeId[0].required = value === 1;
      this.form.requestContent = "";
      this.form.initActivities = [];
      if (value === 0 || value === 6) {
        this.iDate = "";
        this.iTime = "";
        this.form.interactionTypeId = null;
      }
      if (value === 1) {
        this.setTimeInputListener("iTime");
      }
    },
    setTimeInputListener(ref) {
      this.$nextTick(() => {
        // const timeDom = this.$refs[ref];
        let refsData = this.$refs[ref];
        const timeDom = Array.isArray(refsData) ? refsData[0] : refsData;
        if (timeDom) {
          const input = timeDom.$refs.reference;
          input.$on("input", (value) => {
            value = value.length > 5 ? value.substring(0, 5) : value;
            value = value.replace(/[^0-9:\uff1a]/g, "").replace(/\uff1a/g, ":");
            timeDom.$set(timeDom, "selectedLabel", value);
          });
        }
      });
    },
    onScheduleChange(value) {
      this.formRules.scheduleDate[0].required = value;
      if (!value) {
        this.sDate = "";
        this.sTime = "";
      }
      if (value) {
        this.setTimeInputListener("sTime");
      }
    },
    onSelectDialogClosed() {
      this.dialogVisible = true;
    },
    onSelect(selected) {
      this.selectTableData = this.selectTableData.concat(selected);
      this.uploadFiles = this.uploadFiles.concat(selected);
      if (selected.length > 0) {
        this.$refs.form.clearValidate("papers");
        // 直接更新为文件名（如果需要清空Description，会通过clear-description事件处理）
        this.updateDescriptionFromFiles();
      }
    },
    onClearDescription() {
      this.clearDescription();
      this.updateDescriptionFromFiles();
      // 更新原始文件列表，以便下次判断文件变化时使用最新状态
      this.originalPaperContent = this.form.paperContent;
    },
    onOpen() {
      this.getAllData();
      this.form.pushToMSL = this.$store.state.userInfo.bindStatus === 2;
      // Initialize original paper content for new dialog
      if (!this.data) {
        this.originalPaperContent = "";
      }
      if (this.data && !this.hidePushDialog) {
        this.form.pushToMSL = this.data.PushToMSL;
        this.form.isWeComSend = this.data.IsWeComSend==1;
        this.form.contactsOnly = this.data.ContactsOnly==1;
        this.form.greeting = this.data.MessageTitle
        this.form.seIds = this.data.SEIDs.split(',');
        this.form.requestType = this.data.OneTimeRequest;
        this.form.scheduled = this.data.Scheduled
        this.form.scheduleDate = this.data.ScheduleDate
        this.sDate = this.form.scheduleDate.split(' ')[0]
        this.sTime = this.form.scheduleDate.split(' ')[1]
        this.form.interactionTypeId = this.data.InteractionTypeID
        this.form.interactionDateTime = this.data.InteractionDateTime
        this.iDate = this.form.interactionDateTime.split(' ')[0]
        this.iTime = this.form.interactionDateTime.split(' ')[1]
        this.form.requestContent = this.data.RequestContent
        this.form.initActivities = this.data.initActivities
        this.form.fullPaperRequest = this.data.FullPaperRequest
        this.getMsgContent()
      }
    },
    getMsgContent() {
      let params = {
        batchId: this.data.BatchID
      }
      this.axios
        .get("/combinePush/messageContent", {
          params: params,
        })
        .then(({ code, data }) => {
          if (code === 200 && data) {
            this.selectTableData = data.content
            this.uploadFiles = data.content
            this.form.paperContent = data.pushDetails.paperContent
            // Set original paper content for edit mode
            this.originalPaperContent = data.pushDetails.paperContent
            
          }
        });
    },
    getAllData() {
      this.loading = true
      this.requestTypeLoading = true
      this.checkBindWeChatStatus();
      this.$axios
        .all([
          this.axios.get("/combinePush/seList"),
          this.axios.get("/combinePush/param"),
        ])
        .then((res) => {
          this.handleSEResp(res[0]);
          this.handleParamsResp(res[1]);
          this.hidePushDialog = false;
          this.loading = false
        });
    },
    getDataBySEIDs(dataArray, targetSEIDs) {
      return dataArray.filter(item => targetSEIDs.includes(item.SEID));
    },
    handleSEResp({ code, data }) {
      if (code === 200) {
        this.seList = data.map((item) => ({
          ...item,
        }));
        // //本地测试mock数据
        // if(this.isMock){
        //   this.seList[1].IsWeComEnabled=true
        //   this.seList[2].IsWeComEnabled=false
        // }
        if (!this.hidePushDialog) {
          if (data.length > 0) {
            if (this.data) {
              //代替原有逻辑
              const result = this.getDataBySEIDs(this.seList, this.form.seIds);
              if (result.length > 0) {
                this.form.seIds = result.map(item => item.SEID)
              } else {
                this.form.seIds = []
              }
            }
            // let seIds = []
            // if (this.seId && result.length > 0) {
            //   //如果打开有带入的seId并且当前用户的selist有他，回显。否则清空，不然会出现uuid的情况
            //   seIds = [this.seId]
            // }
            // this.form.seIds = seIds
            // // this.form.seIds = this.seId ? [this.seId] : [];
          }
        }
        // 处理编辑模式下的contactsOnly回显过滤
            this.handleContactsOnlyFilter();
      }
    },
    showSelectDialog() {
      this.hidePushDialog = true;
      this.dialogVisible = false;
      this.selectContentDialogVisible = true;
    },
    showNewPaperDialog() {
      this.hidePushDialog = true;
        this.dialogVisible = false;
        this.newPaperDialogVisible = true;
    },
    handleParamsResp({ code, data }) {
      this.requestTypeLoading = false
      if (code === 200) {
        this.priorities = data.priority;
        this.pushTypes = data.pushType;
        this.activityOptions = data.initActivitiesParams;
        this.interTypes = data.interType;
        if (!this.hidePushDialog) {
          // this.form.requestType =
          //   data.pushType.length > 0 ? data.pushType[0].key : "";
          // this.form.categoried =
          //   data.categoried.length > 0 ? data.categoried[0].key : "";
          // this.form.priority =
          //   data.priority.length > 0 ? data.priority[0].key : "";
          // this.form.interactionTypeId =
          //   data.interType.length > 0 ? data.interType[0].key : "";
        }
      }
    },
    handleBusinessPurposeListResp({ code, data }) {
      if (200 === code) {
        this.$set(this, "businessPurposeList", data);
      }
    },
    handleSecurityLevelListResp({ code, data }) {
      if (200 === code) {
        this.$set(this, "securityLevelsList", data);
      }
    },
    checkBindWeChatStatus() {
      this.axios
        .get("/user/bind", {
          headers: {
            showLoading: false,
          },
        })
        .then(({ code, data }) => {
          if (code === 200 && data) {
            const bindStatus = data.bindStatus;
            this.$store.commit("updateState", {
              userInfo: {
                ...this.userInfo,
                bindStatus,
              },
            });
          }
        });
    },
    bindWeChat() {
      this.bus.$emit("bindWeChat");
    },
    onSESelectChange({ isUncertified }) {
      this.isSelectSEUncertified = isUncertified;
      this.$set(
        this.formRules.pushToMSL,
        "required",
        this.isSelectSEUncertified
      );
      if (this.isSelectSEUncertified) {
        this.$refs.form.validateField("pushToMSL");
      } else {
        this.$refs.pushToMSL.clearValidate();
      }
    },
    onFileUpload(files) {
      console.log(files)
      let _files = files.map(item => ({
        ...item,
        Content: item.FileName,
      }));
      this.selectTableData = this.selectTableData.concat(_files)
      this.uploadFiles = this.uploadFiles.concat(_files);
      // Update Description with new files' descriptions
      this.updateDescriptionFromFiles();
    },
    deleteFile(i) {
      // 如果是最后一个文件或者Description有修改，都需要弹出确认提示
        const message = '调整文件后，现有Description将清空，进行重新加载';
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.executeDeleteFile(i);
          this.onClearDescription();
        }).catch(() => {
          // 用户取消，不执行删除
        });
    },
    executeDeleteFile(i) {
      let deleteFile = this.uploadFiles[i]
      this.selectTableData = this.selectTableData.filter(item => item.PaperID != deleteFile.PaperID)
      this.uploadFiles.splice(i, 1);
    },
    clearDescription() {
      this.form.paperContent = "";
      this.originalPaperContent = "";
    },
    updateDescriptionFromFiles() {
      // Collect file names from all files
      const validFiles = this.uploadFiles
        .map(file => file.Description )
      
      let formattedContent = '';
        formattedContent = validFiles
          .map((Description, index) => `<p>${index + 1}.${Description?Description:'-'}</p>`)
          .join('\n');

      console.log(formattedContent)
      this.form.paperContent = formattedContent;
      this.originalPaperContent = formattedContent;
    },
    onPreview() {
      let valid = true;
      this.$refs.form.validateField(
        ["paperContent",'greeting'],
        (result) => {
          if (valid) {
            valid = result.length === 0;
          }
        }
      );
      if (valid) {
        const data = {
          ...this.form,
          greeting: this.form.greeting.trim(),
          funType:'combinePush'
        };
        this.previewing = true;
        this.axios
          .post("/content/preview", data)
          .then(({ code, data }) => {
            if (code == 200) {
              this.previewUrl = data.url;
              this.qrcodeDialogVisible = true;
            } else {
              this.$message.error("Get preview qrcode failed");
            }
            this.previewing = false;
          })
          .catch(() => {
            this.previewing = false;
          });
      }
    },
    selectedSEValidate() {
      return (
        this.form.seIds.length > 1 &&
        this.form.seIds.some((seId) => {
          return this.seList.some((se) => se.SEID === seId && !se.Certified);
        })
      );
    },
    formValidate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return;
          }
          if (this.selectedSEValidate()) {
            const str = this.$store.state.role === RoleCode.VMSL ? 'vCE' : 'HCP';
            this.$message.error(
              `Selected ${str} is currently invalid or has been transferred, please cancel your selected.`
            );
            return;
          }
          if (!this.isSelectSEUncertified) {
            resolve();
            return;
          }
          let message = "HCP";
          if (
            this.userInfo.role === RoleCode.ClinTrans ||
            this.userInfo.role === RoleCode.SciCom ||
            this.userInfo.role === RoleCode.CRP ||
            this.userInfo.role === RoleCode.CVEO
          ) {
            message = "Customer";
          }
          this.$alert(
            `The selected ${message} is uncertified, please forward to the target ${this.nameLabel}.`,
            {
              type: "warning",
              confirmButtonText: "OK",
              callback: () => {
                resolve();
              },
            }
          );
        });
      });
    },
    goToSubmit(status) {
      // 检查seIds是否为空
      if ((this.form.isWeComSend && !this.form.contactsOnly) && (!this.form.seIds || this.form.seIds.length === 0)) {
        this.$message.error('请至少选择一个HCP');
        this.actionDisabled = false;
        return;
      }
      this.actionDisabled = true;
      //生成个weComTypeList，是选中得seId，对应seList里对应所有信息用于提效时候用
      let weComTypeList = this.form.seIds.map(seId => {
        let se = this.seList.find(se => se.SEID === seId);
        return {
          SEID: seId,
          IsWeComEnabled: se.IsWeComEnabled,
          Name: se.Name,
          ExternalUserId: se.ExternalUserId,
        }
      })
      const data = {
        status,
        ...this.form,
        greeting: this.form.greeting.trim(),
        funType:'combinePush',
        weComTypeList,
      };
      if (this.data) {
        data.batchId = this.data.BatchID
      }
      const url = this.data ? "/push/update" : "/push/add";

      
      this.axios
        .post(url, data)
        .then(({ code, msg, data }) => {
          if (200 === code) {
            this.$emit("success");
            this.$message.success(
              status === 1 && data ? data : "Save draft successfully"
            );
            this.dialogVisible = false;
          } else if (code === 201) {
            this.dialogVisible = false;
            this.$message.error(msg);
          } else {
            this.$message.error(msg);
            this.actionDisabled = false;
          }
        })
        .catch(() => {
          this.actionDisabled = false;
        });
    },
    alertSubmit(status) {
      // 当contactsOnly选中时，显示自定义的HCP确认对话框
      if (this.form.isWeComSend && !this.form.contactsOnly) {
          //form.seIds和this.seList做过滤，把isWeComEnable为true的seId,放到confirmedContacts，confirmedContacts: ['陈玲', '李天', '吴山', '谢容融'],
        //把isWeComEnable为false的seId,放到unconfirmedContacts，例子 unconfirmedContacts: ['周敏'],
        console.log(this.seList)
        // 同时根据form.seIds过滤联系人，确保只包含已选择的HCP
        this.confirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && se.IsWeComEnabled).map(se => se.Name);
        this.unconfirmedContacts = this.seList.filter(se => this.form.seIds.includes(se.SEID) && !se.IsWeComEnabled).map(se => se.Name);    
        this.customConfirmVisible = true;
      } else {
        // 否则使用原来的确认对话框
        this.$confirm('请确认推送给HCP。', '', {
          confirmButtonText: 'Submit',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.goToSubmit(status);
        }).catch(() => {
          return false;
        });
      }
    },
    // 自定义确认对话框的提交方法
    customConfirmSubmit() {
      // 关闭对话框
      this.customConfirmVisible = false;
      // 调用提交到服务器的方法
      this.goToSubmit(1);
    },
    // 自定义确认对话框的取消方法
  customConfirmCancel() {
    // 关闭对话框
    this.customConfirmVisible = false;
  },
  
  // 处理编辑模式下的contactsOnly回显过滤
  handleContactsOnlyFilter() {
      // 编辑模式下处理contactsOnly回显过滤
      if (this.form.contactsOnly) {
        // 保存原始seList
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        console.log('originalSeList',this.originalSeList)
        // 过滤seList，只保留weComEnable为true的项
        const filteredSeList = this.originalSeList.filter(se => se && se.IsWeComEnabled);
        this.seList = filteredSeList;
        console.log('filteredSeList',filteredSeList)
        // 获取过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(se => se.SEID);
        
        // 重新赋值form.seIds，只保留过滤后的seList中存在的HCP ID，确保勾选状态正确显示
        this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
      }
    },
    
    // Contacts Only复选框变化处理
    onContactsOnlyChange(checked) {
      if (checked) {
        // 过滤seList中weComEnable为true的HCP，并更新到原始seList
        // 先保存原始seList到一个临时变量，以便取消勾选时恢复
        if (!this.originalSeList) {
          this.originalSeList = JSON.parse(JSON.stringify(this.seList));
        }
        
        // 过滤seList，只保留weComEnable为true的项
        const filteredSeList = this.originalSeList.filter(se => se && se.IsWeComEnabled);
        this.seList = filteredSeList;
        
        // 获取过滤后的seList中存在的HCP ID
        const validSeIds = filteredSeList.map(se => se.SEID);
        
        // 如果有选中的HCP，先检查是否有不支持的HCP，再过滤
        if (this.form.seIds.length > 0) {
          // 保存当前选中的HCP ID，用于检查
          const currentSeIds = [...this.form.seIds];
          
          // 检查选中的HCP中是否有weComEnable为false或不在过滤列表中的
          const hasUnsupportedContacts = currentSeIds.some(seId => {
            const se = this.originalSeList.find(s => s.SEID === seId);
            return se && !se.IsWeComEnabled || !validSeIds.includes(seId);
          });
          
          // 情况3：存在weComEnable为false或不在过滤列表中的HCP，需要弹窗确认
          if (hasUnsupportedContacts) {
            this.$confirm('已选择的HCP中有部分HCP没有添加企业微信，勾选”Contacts Only"后，没有添加企业微信的HCP将被过滤，请确认是否继续？', '提示', {
              confirmButtonText: '确定',
            cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 用户同意，过滤掉不支持的HCP
              this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
            }).catch(() => {
              // 用户拒绝，不勾选contactsOnly，并恢复原始seList
              this.form.contactsOnly = false;
              if (this.originalSeList) {
                this.seList = JSON.parse(JSON.stringify(this.originalSeList));
                this.form.seIds = currentSeIds
                this.originalSeList = null;
              }
              return; // 提前返回，避免后续代码执行
            });
          } else {
            // 没有不支持的HCP，直接过滤form.seIds
            this.form.seIds = currentSeIds.filter(seId => validSeIds.includes(seId));
          }
        } else {
          // 没有选中的HCP，直接过滤form.seIds
          this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
        }
      } else {
        // 取消勾选时，恢复原始seList
        if (this.originalSeList) {
          this.seList = JSON.parse(JSON.stringify(this.originalSeList));
          this.originalSeList = null;
        }
        // 恢复form.seIds，确保与原始seList匹配
        const validSeIds = this.seList.map(se => se.SEID);
        this.form.seIds = this.form.seIds.filter(seId => validSeIds.includes(seId));
      }
    },
    onSubmit(status) {
      this.formValidate().then(() => {
        if (this.form.requestType === 6) {
          let noneReason = this.form.requestContent == '' || this.form.requestContent == null
          let noneActivity = this.form.initActivities.length == 0
          if (noneReason && noneActivity) {
            this.$message.error(
              "Please make sure you have input reason or check the checkbox for initiated activities"
            );
            return;
          }
        }   
        if (status == 0) {
          this.goToSubmit(status);
          return;
        }
        this.alertSubmit(status);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0;
    display: flex;
    max-height: 70vh;
  }

  .el-scrollbar.dialog {
    min-width: auto;
  }
}

.el-form-item {
  margin-bottom: 15px !important;

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }


  .push-to-msl-msg {
    position: absolute;
    left: 0px;
    top: 90%;
    color: #f56c6c;
    font-size: 12px;
    line-height: 12px;
  }

  .se-control {
    width: 90%;
    display: flex;

    .el-select {
      flex: 1;
    }

    .el-select+.el-button {
      margin-left: 10px;
    }
  }

  .upload-files {
    margin-top: 5px;

    .upload-file-item {
      position: relative;
      display: inline-flex;
      align-items: center;

      a {
        margin-right: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 300px;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0;
        top: 3px;
        cursor: pointer;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: $theme-color;
        display: none;

        &:hover {
          color: #606266;
        }
      }

      &:hover span {
        display: block;
      }
    }
  }

  .security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
}

.footer {
  text-align: center;
}

::v-deep {
  .top-label {
    margin-bottom: 0px !important;
  }

  .top-label .el-form-item__label {
    position: static !important;
    /* 覆盖默认的相对定位 */
    float: none !important;
    /* 移除浮动 */
    width: 100% !important;
    /* 设置宽度为100% */
  }

  .top-label .el-form-item__content {
    margin-left: 0 !important;
    /* 移除默认的左边距 */
  }

  .row-line {
    width: 90%;

    .el-form-item .el-select {
      width: 100% !important;
    }
  }
}

.activity_options {
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

::v-deep {
  .custom-confirm-dialog{
    .el-dialog__body{
      width: 100%;
      display: block;
      padding: 10px 30px;
          color: #000000;
    }
  }
}
.confirm-divider{
      width: 100%;
    height: 1px;
    background: #dddddd;
    margin: 20px 0;
}
</style>
